import React from 'react';
import Button from "@mui/material/Button";

export const DiscardCardsState = ({state, userId, setConfirmAction}) => {

    const nbCards = state.actions[userId][0].nbCards;
    const [discardedCards, setDiscardedCards] = React.useState(state.actions[userId][0].cardsToDiscard.map(() => false));

    return <div>
        <h2>
            Vous devez défausser {nbCards} carte{nbCards > 1 ? "s" : ""} :
        </h2>
        <div>
            {
                state.actions[userId][0].cardsToDiscard.map((a, i) => <div
                    style={{
                        width: '100%',
                        backgroundColor: "#2a2d4a",
                        borderRadius: "8px",
                        display: "flex",
                        marginBottom: "8px",
                        padding: "10px 15px",
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        transition: 'all 0.2s ease',
                        boxSizing: 'border-box',
                    }}
                    key={a.name}>


                    <div style={{flex: 1, fontSize: "16px"}}>
                        {a.name}
                    </div>
                    <div>
                        <Button
                            variant={discardedCards[i] ? "contained" : "outlined"}
                            onClick={() => setDiscardedCards(d => d.map((v, j) => i === j ? !v : v))}
                            sx={{minWidth: '80px'}}
                        >
                            Discard{discardedCards[i] ? "ed" : ""}
                        </Button>
                    </div>

                </div>)
            }
        </div>
        <div>
            {/*If not enough or too much cards selected to discard, display a message here*/}
            <div>
                {
                    discardedCards.filter(d => d).length < nbCards &&
                    <div style={{textAlign: "center"}}>
                        Veuillez sélectionner {nbCards - discardedCards.filter(d => d).length} carte{nbCards - discardedCards.filter(d => d).length > 1 ? "s" : ""} supplémentaire{nbCards - discardedCards.filter(d => d).length > 1 ? "s" : ""} à défausser
                    </div>
                }
                {
                    discardedCards.filter(d => d).length > nbCards &&
                    <div style={{textAlign: "center"}}>
                        Veuillez désélectionner {discardedCards.filter(d => d).length - nbCards} carte{discardedCards.filter(d => d).length - nbCards > 1 ? "s" : ""} à défausser
                    </div>
                }
            </div>
            <Button
                variant={"contained"}
                disabled={discardedCards.filter(d => d).length !== nbCards}
                onClick={() => setConfirmAction({
                    action: {...state.actions[userId][0], cardsToDiscard: state.actions[userId][0].cardsToDiscard.filter((c, i) => discardedCards[i])},
                    message: "Êtes-vous sûr de vouloir défausser ces cartes ?"
                })}
                sx={{minWidth: '80px'}}
            >
                Valider
            </Button>
        </div>
    </div>


}
export default DiscardCardsState;
